import ReportDataTable from "./ReportDataTable";
import { ReportRow } from "../types";

const VehicleReport = ({ rows }: { rows: ReportRow[] }) => (
  <ReportDataTable rows={rows} emptyMessage="No vehicle report data found." />
);

export default VehicleReport;
